import { render } from "./TrainVehicleCard.vue?vue&type=template&id=458eeef1"
import script from "./TrainVehicleCard.vue?vue&type=script&lang=ts"
export * from "./TrainVehicleCard.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBtn});qInstall(script, 'directives', {Ripple});
